<div class="bread-crumb-container"
  [ngStyle]="{'background': (currentPath == 'receipt' ? 'white' : 'linear-gradient(180deg, #f4f4f4 0%, #f7f2fc 100%)') }"
  *ngIf="breadcrumbs && breadcrumbs.length>1">
  <div class="bread-crumb-container-row">
    <div *ngFor="let breadcrumb of breadcrumbs; let last = last">
      <a [routerLink]="breadcrumb.url" class="bread-crumb" [ngStyle]="{'color': last ? '#707070' : '#6400DC'}">
        {{ breadcrumb.label }} <span *ngIf="!last" style="margin-left: 15px;">/</span></a>
    </div>
  </div>
</div>